import React, { useEffect, useState } from 'react'
import { Users } from 'lucide-react'
import DynamicProfileImage from 'components/commons/DynamicProfileImage'
import collaboratorsApi from 'api/requests/collaborators'
import { Card, Label, List, Person, Info, Name, Pending, Origin } from './PeopleCard'

const AVATAR_SIZE = '40px'

function originLabel(origin) {
    if (origin.type === 'invite') {
        return 'Convidado do evento'
    }

    return origin.panel_wide ? `Equipe: ${origin.name} (painel inteiro)` : `Equipe: ${origin.name}`
}

function origins(person) {
    return person.origins.map(originLabel).join(' · ')
}

/**
 * Convidados do evento e pessoas das equipes que têm acesso a ele, com a foto
 * de cada um (sem foto, a inicial). Quem ainda não aceitou aparece como
 * pendente. Sem ninguém convidado, o cartão nem aparece.
 */
export default function EventPeople({ slug }) {
    const [people, setPeople] = useState([])

    useEffect(() => {
        let active = true

        collaboratorsApi.getPeople(slug)
            .then(({ data }) => active && setPeople(data?.data || []))
            .catch(() => active && setPeople([]))

        return () => { active = false }
    }, [slug])

    if (people.length === 0) {
        return null
    }

    return (
        <Card>
            <Label>
                <Users size={13} aria-hidden='true' />
                Equipe e convidados · {people.length}
            </Label>

            <List>
                {people.map(person => (
                    <Person key={person.user_id}>
                        <DynamicProfileImage size={AVATAR_SIZE} img={person.photo} word={person.name || person.email} />

                        <Info>
                            <Name title={person.email}>
                                {person.name || person.email}
                                {person.status === 'pending' && <Pending>Pendente</Pending>}
                            </Name>
                            <Origin title={origins(person)}>{origins(person)}</Origin>
                        </Info>
                    </Person>
                ))}
            </List>
        </Card>
    )
}
